// extracted by mini-css-extract-plugin
export default {"wrapper":"Stripe_wrapper__VhZds","paymentInfo":"Stripe_paymentInfo__4bYJR"};